
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forums/ForumBoardPage/ForumBoardPage",
      function () {
        return require("private-next-pages/forums/ForumBoardPage/ForumBoardPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forums/ForumBoardPage/ForumBoardPage"])
      });
    }
  